// assets/top-marquee.js
(() => {
  if (window.__everbrandsTopMarqueeLoaded) return;
  window.__everbrandsTopMarqueeLoaded = true;

  /* ================================
     CONFIG
  ================================= */

  // Add / remove messages here
  const MESSAGES = [
    "FREE SHIPPING ON ORDERS ABOVE $26 📦"
    // "Another message here",
  ];

  const BG_COLOR = "#000";
  const TEXT_COLOR = "#fff";
  const BAR_MIN_HEIGHT = 38;     // px
  const SPEED_PX_PER_SEC = 35;   // marquee speed
  const SHOW_ONLY_AT_TOP_SCROLL_Y = 0;
  const NAV_SELECTOR = "nav.awemenu-nav";

  /* ================================
     STYLES
  ================================= */

  function injectStyles() {
    const css = `
      :root { --everbrands-topbar-h: 0px; }

      .everbrands-topbar {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;
        width: 100%;
        background: ${BG_COLOR};
        color: ${TEXT_COLOR};
        overflow: hidden;
        opacity: 0;
        pointer-events: none;
        transform: translateY(-100%);
        transition: opacity 160ms ease, transform 160ms ease;
      }

      .everbrands-topbar.is-visible {
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0);
      }

      .everbrands-topbar__inner {
        display: flex;
        align-items: center;
        min-height: ${BAR_MIN_HEIGHT}px;
        padding-top: env(safe-area-inset-top, 0px);
      }

      .everbrands-topbar__viewport {
        overflow: hidden;
        width: 100%;
      }

      .everbrands-topbar__track {
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        will-change: transform;
      }

      .everbrands-topbar__item {
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        padding: 10px 18px;
      }

      .everbrands-topbar__sep {
        opacity: 0.6;
        padding: 0 4px;
      }

      ${NAV_SELECTOR} {
        top: var(--everbrands-topbar-h) !important;
      }

      @media (prefers-reduced-motion: reduce) {
        .everbrands-topbar { display: none; }
      }
    `;

    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ================================
     MARKUP
  ================================= */

  function buildBar() {
    const bar = document.createElement("div");
    bar.className = "everbrands-topbar";
    bar.setAttribute("role", "region");
    bar.setAttribute("aria-label", "Site announcements");

    const inner = document.createElement("div");
    inner.className = "everbrands-topbar__inner";

    const viewport = document.createElement("div");
    viewport.className = "everbrands-topbar__viewport";

    const track = document.createElement("div");
    track.className = "everbrands-topbar__track";

    const makeItem = (txt) => {
      const el = document.createElement("span");
      el.className = "everbrands-topbar__item";
      el.textContent = txt;
      return el;
    };

    const sep = () => {
      const el = document.createElement("span");
      el.className = "everbrands-topbar__sep";
      el.textContent = "•";
      return el;
    };

    // Repeat message sequence enough to fill large screens
    const repeats = 12;
    for (let i = 0; i < repeats; i++) {
      MESSAGES.forEach((msg, idx) => {
        track.appendChild(makeItem(msg));
        if (idx < MESSAGES.length - 1) track.appendChild(sep());
      });
      track.appendChild(sep());
    }

    viewport.appendChild(track);
    inner.appendChild(viewport);
    bar.appendChild(inner);

    return { bar, track };
  }

  /* ================================
     MARQUEE ANIMATION
  ================================= */

  function animateMarquee(track) {
    let start = null;

    const tick = (ts) => {
      if (!start) start = ts;

      const contentWidth = track.scrollWidth;
      if (!contentWidth) {
        requestAnimationFrame(tick);
        return;
      }

      const duration = (contentWidth / SPEED_PX_PER_SEC) * 1000;
      const elapsed = ts - start;
      const progress = (elapsed % duration) / duration;

      track.style.transform = `translateX(${-progress * contentWidth}px)`;
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }

  /* ================================
     NAV OFFSET HANDLING
  ================================= */

  function setNavOffset(px) {
    document.documentElement.style.setProperty("--everbrands-topbar-h", `${px}px`);
    const nav = document.querySelector(NAV_SELECTOR);
    if (nav) nav.style.setProperty("top", `${px}px`, "important");
  }

  function observeNavStyleChanges(getTop) {
    const nav = document.querySelector(NAV_SELECTOR);
    if (!nav || !("MutationObserver" in window)) return;

    const obs = new MutationObserver(() => {
      nav.style.setProperty("top", `${getTop()}px`, "important");
    });

    obs.observe(nav, { attributes: true, attributeFilter: ["style", "class"] });
  }

  /* ================================
     INIT
  ================================= */

  function init() {
    injectStyles();

    const { bar, track } = buildBar();
    document.body.insertBefore(bar, document.body.firstChild);

    let currentTopPx = 0;

    const applyState = () => {
      const y = window.scrollY || 0;
      const atTop = y <= SHOW_ONLY_AT_TOP_SCROLL_Y;

      if (atTop) {
        bar.classList.add("is-visible");
        const h = Math.ceil(bar.getBoundingClientRect().height) || BAR_MIN_HEIGHT;
        currentTopPx = h;
        setNavOffset(h);
      } else {
        bar.classList.remove("is-visible");
        currentTopPx = 0;
        setNavOffset(0);
      }
    };

    observeNavStyleChanges(() => currentTopPx);

    window.addEventListener("scroll", applyState, { passive: true });
    window.addEventListener("resize", applyState, { passive: true });
    setTimeout(applyState, 50);
    setTimeout(applyState, 250);
    setTimeout(applyState, 800);

    applyState();
    animateMarquee(track);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
